export const useTrackingFlow = ({
  selectedProductLevel,
  highestOwnedProductLevel
}) => {
  if (!selectedProductLevel || !highestOwnedProductLevel || selectedProductLevel === 'FREE') {
    return '';
  }
  return `${String(highestOwnedProductLevel)}-to-${String(selectedProductLevel)}`.toLowerCase();
};